import React, { useEffect, useState } from "react";
import { adultRank, childRank } from "../constants/belts";
import { fetchAllStudents } from "../services/studentService";

export default function SummaryPage() {
  const [studentsData, setStudentsData] = useState([]);
  const [childStudents, setChildStudents] = useState([]);
  const [adultStudents, setAdultStudents] = useState([]);
  const [noCategoryStudents, setNoCategoryStudents] = useState([]);
  useEffect(() => {
    fetchAllStudents()
      .then((res) => {
        setStudentsData(res.data);
      })
      .catch((err) => console.error("Erreur fetch students :", err));
  }, []);
  useEffect(() => {
    setChildStudents(
      studentsData
        .filter((stud) => stud.rank && stud.rank.category === "enfant")
        .sort(
          (a, b) =>
            a.rank.level - b.rank.level || a.surname.localeCompare(b.surname)
        )
    );

    setAdultStudents(
      studentsData
        .filter((stud) => stud.rank && stud.rank.category === "adulte")
        .sort(
          (a, b) =>
            a.rank.level - b.rank.level || a.surname.localeCompare(b.surname)
        )
    );
    setNoCategoryStudents(
      studentsData
        .filter((stud) => !stud.rank)
        .sort((a, b) => a.surname.localeCompare(b.surname))
    );
  }, [studentsData]);

  function generateTableByLevel(level, list) {
    if (!list || list.length === 0) return null;

    const category = list[0]?.rank?.category || "non défini";
    const imgSrc =
      category === "enfant"
        ? childRank.find((x) => x.value === list[0].rank.level)?.label ||
          "Inconnu"
        : category === "adulte"
        ? adultRank.find((x) => x.value === list[0].rank.level)?.label ||
          "Inconnu"
        : "Catégorie non définie";

    return (
      <>
        <h2 className="text-2xl font-semibold mb-1 flex items-center">
          {imgSrc}
        </h2>
        <table className="min-w-full table-auto border-collapse text-left mb-5">
          <thead className="bg-gray-200 text-gray-700">
            <tr>
              <th className="px-4 py-2 border-b font-semibold w-12">
                Position
              </th>
              <th className="px-4 py-2 border-b font-semibold w-40">
                Nom Prenom
              </th>
              <th className="px-4 py-2 border-b font-semibold w-24">Jury 1</th>
              <th className="px-4 py-2 border-b font-semibold w-24">Jury 2</th>
              <th className="px-4 py-2 border-b font-semibold w-24">Jury 3</th>
              <th className="px-4 py-2 border-b font-semibold w-24">Jury 4</th>
              <th className="px-4 py-2 border-b font-semibold w-24">Total</th>
            </tr>
          </thead>
          <tbody className="text-gray-600">
            {list.map((student, index) => {
              const jury1 = student.notes
                .filter((x) => x.module.id <= 7)
                .reduce((sum, note) => sum + note.value, 0);
              const jury2 = student.notes
                .filter((x) => x.module.id > 7 && x.module.id <= 10)
                .reduce((sum, note) => sum + note.value, 0);
              const jury3 = student.notes
                .filter((x) => x.module.id > 10 && x.module.id <= 13)
                .reduce((sum, note) => sum + note.value, 0);
              const jury4 = student.notes
                .filter((x) => x.module.id > 13)
                .reduce((sum, note) => sum + note.value, 0);

              const total = jury1 + jury2 + jury3 + jury4;

              return (
                <tr key={index} className="hover:bg-gray-100">
                  <td className="px-4 py-2 border-b">{index + 1}</td>
                  <td className="px-4 py-2 border-b">
                    {student.surname} {student.name}
                  </td>
                  <td className="px-4 py-2 border-b">{jury1}</td>
                  <td className="px-4 py-2 border-b">{jury2}</td>
                  <td className="px-4 py-2 border-b">{jury3}</td>
                  <td className="px-4 py-2 border-b">{jury4}</td>
                  <td className="px-4 py-2 border-b">{total}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </>
    );
  }

  return (
    <div className="relative top-[20vh] max-sm:top-[10vh] p-5 h-[80vh] overflow-scroll">
      {childStudents.length > 0 && (
        <h2 className="text-2xl font-bold">Enfants</h2>
      )}
      {[...new Set(childStudents.map((el) => el.rank.level))].map((level) => (
        <React.Fragment key={level}>
          {generateTableByLevel(
            level,
            childStudents.filter((x) => x.rank.level === level)
          )}
        </React.Fragment>
      ))}

      {adultStudents.length > 0 && (
        <h2 className="text-2xl font-bold">Adultes</h2>
      )}
      {[...new Set(adultStudents.map((el) => el.rank.level))].map((level) => (
        <React.Fragment key={level}>
          {generateTableByLevel(
            level,
            adultStudents.filter((x) => x.rank.level === level)
          )}
        </React.Fragment>
      ))}

      {noCategoryStudents.length > 0 && (
        <React.Fragment key="no-category">
          {generateTableByLevel("non défini", noCategoryStudents)}
        </React.Fragment>
      )}
    </div>
  );
}
